import { useMemo } from "react";
import { ImageIcon } from "lucide-react";
import { PROOF_IMAGES } from "../../data/mock";

const ProofCard = ({ item }) => (
  <div
    className="h-80 w-60 shrink-0 overflow-hidden rounded-2xl border border-white/10 bg-[#0b0d10]"
    data-testid={`proof-card-${item.key}`}
  >
    {item.src ? (
      <img src={item.src} alt={item.alt} className="h-full w-full object-cover" />
    ) : (
      <div className="flex h-full w-full flex-col items-center justify-center gap-3 text-zinc-600">
        <ImageIcon className="h-8 w-8" />
        <span className="px-4 text-center text-xs">Your result photo here</span>
      </div>
    )}
  </div>
);

export const Proof = () => {
  const doubled = useMemo(
    () => [...PROOF_IMAGES, ...PROOF_IMAGES].map((item, i) => ({ ...item, key: `${item.id}-${i}` })),
    []
  );

  return (
    <section id="proof" className="overflow-hidden py-16 sm:py-24" data-testid="proof-section">
      <p className="text-center text-xs uppercase tracking-[0.3em] text-[#2f7fff] mb-4">Verified</p>
      <h2 className="font-heading text-center text-3xl sm:text-4xl uppercase tracking-tight text-white mb-14 px-4">
        Supplier Proof + <span className="text-gradient-blue">Student Results</span>
      </h2>

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#050608] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#050608] to-transparent" />
        <div className="marquee flex gap-5 w-max">
          {doubled.map((item) => (
            <ProofCard key={item.key} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};
